declare namespace $ {

	type $mol_view__sub_bog_fragile_demo_collide_child2_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_fragile_demo_collide_child2 extends $bog_fragile_demo_collide_base2 {
		icon( ): string
		Attach( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=child2.view.tree.d.ts.map